const styles = {
  btnContainer: {
    // width: '100%',
    position: 'relative',
    height: { xs: 48, sm: 40 },
    border: '1.3px solid',
    borderColor: (theme) => `${theme.palette.text.grey200}!important`,
    '&.MuiButton-root': {
      borderRadius: '0px 4px 4px 0px!important',
    },
    '&.MuiButton-root:hover': {
      border: '1.3px solid',
      borderColor: (theme) => `${theme.palette.primary.main}!important`,
    },
  },
  chip: {
    position: 'absolute',
    top: 0,
    right: 10,
    backgroundColor: 'secondary.main',
    color: '#fff !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
    borderRadius: '50%',
    height: '20px',
    '&.MuiChip-label': {
      border: '2px solid red',
    },
    '& .MuiTypography-root.MuiTypography-quote': {
      color: 'text.white',
    },
  },
}

export default styles
